import React from 'react'
import {
  Menu,
  MenuItem,
  MenuButton,
  SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import ico_reserve from "./resources_catalog/icons/ico_reserve_white.svg";
import logo from "./resources_catalog/icons/ico_catalog.svg";
import bottom_arrow from "./resources_catalog/icons/ico_bottom_arrow.svg";
import { useHistory } from 'react-router-dom';

const CatalogHeaderMenuPc = (props) => {
  const history = useHistory();

  return (
    <div>
      <div>
        <Menu menuButton={
          <div>
            <MenuButton className="catalogHeaderMenuHead">
              <p>ホテルラインナップ</p>
              <img src={bottom_arrow} alt="" />
            </MenuButton>
            <div className="catalogHeaderMenuListBorder"></div>
          </div>
        }>
          <MenuItem onClick={() => history.push("/rtcc/catalog/hotelLineupJp")}>RTCC宿泊<br />(国内・海外手配旅行)</MenuItem>
          <MenuItem onClick={() => history.push("/rtcc/catalog/hotelLineupOverseas")}>RTCCハワイ<br />(海外募集型企画旅行)</MenuItem>
        </Menu>
      </div>
      <div>
        <Menu menuButton={
          <div>
            <MenuButton className="catalogHeaderMenuHead">
              <p><a href="/rtcc/catalog/aboutService">RTCC旅行業サービスとは</a></p>
            </MenuButton>
            <div className="catalogHeaderMenuListBorder"></div>
          </div>
        }>
        </Menu>
      </div>
      <div>
        <Menu menuButton={
          <div>
            <MenuButton className="catalogHeaderMenuHeadHowTo">
              <p>予約方法</p>
              <img src={bottom_arrow} alt="" />
            </MenuButton>
            <div className="catalogHeaderMenuListBorder"></div>
          </div>
        }>
          <MenuItem onClick={() => history.push("/rtcc/catalog/howToReserveJp")}>RTCC宿泊<br />(国内・海外手配旅行)</MenuItem>
          <MenuItem onClick={() => history.push("/rtcc/catalog/howToReserveOverseas")}>RTCCハワイ<br />(海外募集型企画旅行)</MenuItem>
        </Menu>
      </div>
      <div>
        <Menu menuButton={
          <div>
            <MenuButton className="catalogHeaderMenuHead">
              <p><a href="/rtcc/catalog/question">よくあるご質問</a></p>
            </MenuButton>
            <div className="catalogHeaderMenuListBorder"></div>
          </div>
        }>
        </Menu>
      </div>
      <div className="catalogHeaderMenuButtonBlack">
        <div className="catalogHeaderMenuHeadBlack" onClick={props.onClick}>
          <img src={ico_reserve} alt="" />
          <p>宿泊のご予約</p>
        </div>
      </div>
      {/* <Menu menuButton={<MenuButton>ボタン</MenuButton>} className="catalogHeaderWrap">
        <MenuItem className="catalogHeaderMenu">
          <div className="catalogHeader">
            <div className="catalogHeaderLogo">
              <img src={logo} alt="" />
            </div>
            <div className="catalogHeaderMenuWrap">

              <div className="catalogHeaderMenuButton">
                <div className="catalogHeaderMenuHead">
                  <p>ホテルラインナップ</p>
                  <img src={bottom_arrow} alt="" />
                </div>
                <SubMenu label="Open" className="catalogHeaderMenuListWrap">
                  
                
                  <ul className="catalogHeaderMenuList">
                    <li>国内ホテル</li>
                    <li>海外ホテル</li>
                  </ul>

                </SubMenu>
              </div>

            </div>

            {/* 
      <div className="catalogHeaderMenu">
        <div className="catalogHeaderMenuButton">
          <div className="catalogHeaderMenuHead">
            <p>ホテルラインナップ</p>
            <img src={bottom_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuListWrap">
            <div className="catalogHeaderMenuListBorder"></div>
            <ul className="catalogHeaderMenuList">
              <li>国内ホテル</li>
              <li>海外ホテル</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="catalogHeaderMenu">
        <div className="catalogHeaderMenuButton">
          <div className="catalogHeaderMenuHead">
            <p>RTCC旅行業サービスとは</p>
          </div>
          <div className="catalogHeaderMenuListWrap">
            <div className="catalogHeaderMenuListBorder"></div>
          </div>
        </div>
      </div>
      <div className="catalogHeaderMenu">
        <div className="catalogHeaderMenuButton">
          <div className="catalogHeaderMenuHead">
            <p>ホテルラインナップ</p>
            <img src={bottom_arrow} alt="" />
          </div>
          <div className="catalogHeaderMenuListWrap">
            <div className="catalogHeaderMenuListBorder"></div>
            <ul className="catalogHeaderMenuList">
              <li>国内ホテル</li>
              <li>海外ホテル</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="catalogHeaderMenu">
        <div className="catalogHeaderMenuButton">
          <div className="catalogHeaderMenuHead">
            <p>よくあるご質問</p>
          </div>
          <div className="catalogHeaderMenuListWrap">
            <div className="catalogHeaderMenuListBorder"></div>
          </div>
        </div>
      </div>
      <div className="catalogHeaderMenu">
        <div className="catalogHeaderMenuButtonBlack">
          <div className="catalogHeaderMenuHead">
            <img src={bottom_arrow} alt="" />
            <p>宿泊のご予約</p>
          </div>
        </div>
      </div> */}
      {/* </div>
        </MenuItem>
      </Menu > */}

    </div>
  );
}

export default CatalogHeaderMenuPc;